module.exports = __webpack_public_path__ + "img/cash-money.a755d19e.svg";